module.exports = {
	"name": "amplitudejs",
	"version": "4.0.0",
	"description": "A JavaScript library that allows you to control the design of your media controls in your webpage -- not the browser. No dependencies (jQuery not required) https://521dimensions.com/open-source/amplitudejs",
	"main": "dist/amplitude.js",
	"devDependencies": {
		"babel-core": "^6.18.2",
		"babel-loader": "^7.0.0",
		"babel-plugin-add-module-exports": "0.2.1",
		"babel-polyfill": "^6.16.0",
		"babel-preset-es2015": "^6.18.0",
		"husky": "^1.2.0",
		"jest": "^23.6.0",
		"prettier": "1.15.1",
		"pretty-quick": "^1.8.0",
		"watch": "^1.0.2",
		"webpack": "^2.6.0"
	},
	"directories": {
		"doc": "docs"
	},
	"files": [
		"dist"
	],
	"scripts": {
		"build": "node_modules/.bin/webpack",
		"watch": "watch 'node_modules/.bin/webpack' dist",
		"prettier": "npx pretty-quick",
		"test": "jest"
	},
	"repository": {
		"type": "git",
		"url": "git+https://github.com/521dimensions/amplitudejs.git"
	},
	"keywords": [
		"webaudio",
		"html5",
		"javascript",
		"audio-player"
	],
	"author": "521 Dimensions (https://521dimensions.com)",
	"license": "MIT",
	"bugs": {
		"url": "https://github.com/521dimensions/amplitudejs/issues"
	},
	"homepage": "https://github.com/521dimensions/amplitudejs#readme"
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 59
// module chunks = 0 1